
import { Swiper } from "swiper"; 
import { find } from "../utils/dom";


const instagramApi = async () =>{

	const page = find(`[js-page="blog"]`);
	if(!page) return;

	const accessToken = 'IGAAUORpRMEkdBZAFBEa3gzelgyNTlIelNnTHBDb0FaR1llS1hTNDk2RUhveUt6SDNQT05SbnBIOWZApNnJUazA1dE5QdmxiZA0tleEtQeUhBRDJPNVZAhUm54VDVLZA0o5eXJxd1hJNElRMnhCUXRsdHQ0WktyWC1tQlJwSUFKbGV4YwZDZD';
	const userId = 'me';


	/**
	 * Função: loadingDados
	 * Descrição: Carrega os dados da API do Instagram
	 * Entradas: userId, acessToken
	 * Saidas: Array dos dados da API do Instagram ou Error
	 */
	async function loadingDados(userId, accessToken){
		try {
			const response = await fetch(`https://graph.instagram.com/v23.0/${userId}/media?fields=id,caption,media_url,permalink,thumbnail_url,timestamp&access_token=${accessToken}`);
			if (!response.ok) {
					throw new Error('Failed to fetch media.');
			}
			const data = await response.json();
			return data;
		} catch (error) {
				console.error('Error:', error);
		}
	}


	async function constructSlideSwiper(){
		const dadosApi = await loadingDados(userId, accessToken);
		if(!dadosApi) return;

		let index = 0
		let blocos = []
		for(let i of dadosApi.data){
			if (index % 5 === 0) {
				const bloco = dadosApi.data.slice(index, index + 5);
				blocos.push(bloco);
			}
			index++;
		}

		const swiperWrapper = find(".instagram-swiper .swiper-wrapper");

		swiperWrapper.innerHTML = "";
		
		for(let singleBloco of blocos){

			const $Instagram = {
				imgs:{
					0: (singleBloco[0].thumbnail_url)?singleBloco[0].thumbnail_url:singleBloco[0].media_url,
					1: (singleBloco[1].thumbnail_url)?singleBloco[1].thumbnail_url:singleBloco[1].media_url,
					2: (singleBloco[2].thumbnail_url)?singleBloco[2].thumbnail_url:singleBloco[2].media_url,
					3: (singleBloco[3].thumbnail_url)?singleBloco[3].thumbnail_url:singleBloco[3].media_url,
					4: (singleBloco[4].thumbnail_url)?singleBloco[4].thumbnail_url:singleBloco[4].media_url,
				},
				links:{
					0: singleBloco[0].permalink,
					1: singleBloco[1].permalink,
					2: singleBloco[2].permalink,
					3: singleBloco[3].permalink,
					4: singleBloco[4].permalink
				}
			}


			swiperWrapper.innerHTML += `
			<div class="swiper-slide">
										


			<div class="card-instagram">

				<!-- Primeira Coluna -->
				<div class="coluna-1">
					<a href="${$Instagram.links[0]}" target="_blank" class="item-link">
						<img src="${$Instagram.imgs[0]}" alt="image-blog">
						
						<div class="content-hover">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99467 4.27417H22.0067C25.316 4.27417 28 6.95684 28 10.2688V22.2808C28 25.5902 25.3173 28.2742 22.0053 28.2742H9.99467C6.684 28.2742 4 25.5915 4 22.2795V10.2688C4 6.95817 6.68267 4.27417 9.99467 4.27417V4.27417Z" fill="url(#paint0_linear_5523_2)" fill-opacity="0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22.5987 9.22472C22.3507 9.22606 22.1493 9.42739 22.1493 9.67539C22.1493 9.92339 22.352 10.1247 22.6 10.1247C22.848 10.1247 23.0493 9.92339 23.0493 9.67539C23.0507 9.42606 22.848 9.22472 22.5987 9.22472" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M19.3941 12.88C21.2686 14.7545 21.2686 17.7937 19.3941 19.6682C17.5196 21.5428 14.4804 21.5428 12.6059 19.6682C10.7314 17.7937 10.7314 14.7545 12.6059 12.88C14.4804 11.0055 17.5196 11.0055 19.3941 12.88" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<defs>
								<linearGradient id="paint0_linear_5523_2" x1="12.1659" y1="26.4417" x2="18.4995" y2="13.7745" gradientUnits="userSpaceOnUse">
										<stop stop-color="#ccab78"/>
										<stop offset="1" stop-color="#b8945c"/>
								</linearGradient>
								</defs>
							</svg>
							<span class=" text-white text-pilat-caps-2 sm:text-pilat-caps-4 text-instagram button-ver-instagram">
									Ver Instagram
							</span>
						</div>
					</a>
					
					<a href="${$Instagram.links[1]}" target="_blank" class="item-link">
						<img src="${$Instagram.imgs[1]}" alt="image-blog">
						
						<div class="content-hover">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99467 4.27417H22.0067C25.316 4.27417 28 6.95684 28 10.2688V22.2808C28 25.5902 25.3173 28.2742 22.0053 28.2742H9.99467C6.684 28.2742 4 25.5915 4 22.2795V10.2688C4 6.95817 6.68267 4.27417 9.99467 4.27417V4.27417Z" fill="url(#paint0_linear_5523_2)" fill-opacity="0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22.5987 9.22472C22.3507 9.22606 22.1493 9.42739 22.1493 9.67539C22.1493 9.92339 22.352 10.1247 22.6 10.1247C22.848 10.1247 23.0493 9.92339 23.0493 9.67539C23.0507 9.42606 22.848 9.22472 22.5987 9.22472" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M19.3941 12.88C21.2686 14.7545 21.2686 17.7937 19.3941 19.6682C17.5196 21.5428 14.4804 21.5428 12.6059 19.6682C10.7314 17.7937 10.7314 14.7545 12.6059 12.88C14.4804 11.0055 17.5196 11.0055 19.3941 12.88" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<defs>
								<linearGradient id="paint0_linear_5523_2" x1="12.1659" y1="26.4417" x2="18.4995" y2="13.7745" gradientUnits="userSpaceOnUse">
										<stop stop-color="#ccab78"/>
										<stop offset="1" stop-color="#b8945c"/>
								</linearGradient>
								</defs>
							</svg>
							<span class=" text-white text-pilat-caps-2 sm:text-pilat-caps-4 text-instagram button-ver-instagram">
									Ver Instagram
							</span>
						</div>
					</a>

					<a href="${$Instagram.links[2]}" target="_blank" class="item-link">
						<img src="${$Instagram.imgs[2]}" alt="image-blog">
						
						<div class="content-hover">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99467 4.27417H22.0067C25.316 4.27417 28 6.95684 28 10.2688V22.2808C28 25.5902 25.3173 28.2742 22.0053 28.2742H9.99467C6.684 28.2742 4 25.5915 4 22.2795V10.2688C4 6.95817 6.68267 4.27417 9.99467 4.27417V4.27417Z" fill="url(#paint0_linear_5523_2)" fill-opacity="0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22.5987 9.22472C22.3507 9.22606 22.1493 9.42739 22.1493 9.67539C22.1493 9.92339 22.352 10.1247 22.6 10.1247C22.848 10.1247 23.0493 9.92339 23.0493 9.67539C23.0507 9.42606 22.848 9.22472 22.5987 9.22472" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M19.3941 12.88C21.2686 14.7545 21.2686 17.7937 19.3941 19.6682C17.5196 21.5428 14.4804 21.5428 12.6059 19.6682C10.7314 17.7937 10.7314 14.7545 12.6059 12.88C14.4804 11.0055 17.5196 11.0055 19.3941 12.88" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<defs>
								<linearGradient id="paint0_linear_5523_2" x1="12.1659" y1="26.4417" x2="18.4995" y2="13.7745" gradientUnits="userSpaceOnUse">
										<stop stop-color="#ccab78"/>
										<stop offset="1" stop-color="#b8945c"/>
								</linearGradient>
								</defs>
							</svg>
							<span class=" text-white text-pilat-caps-2 sm:text-pilat-caps-4 text-instagram button-ver-instagram">
									Ver Instagram
							</span>
						</div>
					</a>

					<a href="${$Instagram.links[3]}" target="_blank" class="item-link">
						<img src="${$Instagram.imgs[3]}" alt="image-blog">
						
						<div class="content-hover">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99467 4.27417H22.0067C25.316 4.27417 28 6.95684 28 10.2688V22.2808C28 25.5902 25.3173 28.2742 22.0053 28.2742H9.99467C6.684 28.2742 4 25.5915 4 22.2795V10.2688C4 6.95817 6.68267 4.27417 9.99467 4.27417V4.27417Z" fill="url(#paint0_linear_5523_2)" fill-opacity="0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22.5987 9.22472C22.3507 9.22606 22.1493 9.42739 22.1493 9.67539C22.1493 9.92339 22.352 10.1247 22.6 10.1247C22.848 10.1247 23.0493 9.92339 23.0493 9.67539C23.0507 9.42606 22.848 9.22472 22.5987 9.22472" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M19.3941 12.88C21.2686 14.7545 21.2686 17.7937 19.3941 19.6682C17.5196 21.5428 14.4804 21.5428 12.6059 19.6682C10.7314 17.7937 10.7314 14.7545 12.6059 12.88C14.4804 11.0055 17.5196 11.0055 19.3941 12.88" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<defs>
								<linearGradient id="paint0_linear_5523_2" x1="12.1659" y1="26.4417" x2="18.4995" y2="13.7745" gradientUnits="userSpaceOnUse">
										<stop stop-color="#ccab78"/>
										<stop offset="1" stop-color="#b8945c"/>
								</linearGradient>
								</defs>
							</svg>
							<span class=" text-white text-pilat-caps-2 sm:text-pilat-caps-4 text-instagram button-ver-instagram">
									Ver Instagram
							</span>
						</div>
					</a>
				</div>

				<!-- Segunda Coluna -->
				<div class="coluna-2">
					<a href="${$Instagram.links[4]}" target="_blank" class="item-link">
						<img class="" src="${$Instagram.imgs[4]}" alt="image-blog">
						
						<div class="content-hover">
							<svg class="w-[32px] sm:w-[20px] h-[32px] sm:h-[20px] translate-y-[8rem] group-hover:translate-y-0 transition-transform duration-[.3s] linear" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99467 4.27417H22.0067C25.316 4.27417 28 6.95684 28 10.2688V22.2808C28 25.5902 25.3173 28.2742 22.0053 28.2742H9.99467C6.684 28.2742 4 25.5915 4 22.2795V10.2688C4 6.95817 6.68267 4.27417 9.99467 4.27417V4.27417Z" fill="url(#paint0_linear_5523_2)" fill-opacity="0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M22.5987 9.22472C22.3507 9.22606 22.1493 9.42739 22.1493 9.67539C22.1493 9.92339 22.352 10.1247 22.6 10.1247C22.848 10.1247 23.0493 9.92339 23.0493 9.67539C23.0507 9.42606 22.848 9.22472 22.5987 9.22472" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M19.3941 12.88C21.2686 14.7545 21.2686 17.7937 19.3941 19.6682C17.5196 21.5428 14.4804 21.5428 12.6059 19.6682C10.7314 17.7937 10.7314 14.7545 12.6059 12.88C14.4804 11.0055 17.5196 11.0055 19.3941 12.88" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
								<defs>
								<linearGradient id="paint0_linear_5523_2" x1="12.1659" y1="26.4417" x2="18.4995" y2="13.7745" gradientUnits="userSpaceOnUse">
										<stop stop-color="#ccab78"/>
										<stop offset="1" stop-color="#b8945c"/>
								</linearGradient>
								</defs>
							</svg>
							<span class="text-pilat-caps-2 sm:text-pilat-caps-4 text-instagram button-ver-instagram">
									Ver Instagram
							</span>
						</div>

					</a>
				</div>
			</div>

		</div>

			`
		}
	}


	const SwiperInstagram = new Swiper(".instagram-swiper",{
		slidesPerView: 1,
		spaceBetween: 8,
		pagination: {
			el: ".swiper-pagination",
		},
		navigation: {
			nextEl: ".swiper-button-next-insta",
			prevEl: ".swiper-button-prev-insta",
		},
	})

	constructSlideSwiper()

}

export default instagramApi;
